import {
  setCurrentSearchInfo,
  setMenuCollapsed,
  setApplicationInfo,
  setAIProductDetailInfo,
  setSoundState,
  newTaskState,
  changeMenuTaskFn,
  setMenuOpenList,
  clearCurrentInfo,
  setPrevPage,
  setCurrentReportTime,
  setCurrentCTReportTime,
  nationalDict,
  IDTypeDict,
  cardTypeDict,
} from './current';
import {
  setUserInfo,
  setCTUserInfo,
  clearUserInfo,
  setUserBehaviorTable,
} from './userinfo';
import {
  setAiHeatmapDataSource,
  setAiProductHeatmapData,
  setAiHeatmapData,
  setAiScoresData,
  clearHeatmapInfo,
} from './aiscreen';

import { setDatadictLocationLabels } from './datadict';

const actions = {
  setUserInfo,
  setCTUserInfo,
  clearUserInfo,
  setAiHeatmapDataSource,
  setAiProductHeatmapData,
  clearHeatmapInfo,
  setAiHeatmapData,
  setAiScoresData,
  setCurrentSearchInfo,
  setMenuCollapsed,
  setApplicationInfo,
  setAIProductDetailInfo,
  setSoundState,
  newTaskState,
  changeMenuTaskFn,
  setMenuOpenList,
  clearCurrentInfo,
  setUserBehaviorTable,
  setPrevPage,
  setCurrentReportTime,
  setCurrentCTReportTime,
  nationalDict,
  IDTypeDict,
  cardTypeDict,
  setDatadictLocationLabels,
};

export default actions;
